export enum RouteAction {
  BACK,
  MODULE,
}
